import Shipment from '../model/shipment'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchShipments(workflowID: string): Promise<RequestResponse<Shipment[]>> {
  return secureRequest('GET', url('/v2/shipments', { workflowID }))
}
